<!--
 * @Date: 2023-12-29 10:00:52
 * @LastEditors: fuRan NgeKaworu@gmail.com
 * @LastEditTime: 2023-12-29 10:01:38
 * @FilePath: /newhome-common-h5/src/views/home/index.vue
-->
<template>
  <div>
    <van-notice-bar
      wrapable
      :scrollable="false"
      text="若2.9.1版本之前用户更新后通知仍有异常，请卸载APP重新安装，并按下方指引进行操作。"
    />
    <van-cell-group class="containor">
      <van-cell title="华为手机(除荣耀)" is-link to="/huawei" />
      <van-cell title="小米手机" is-link to="/xiaomi" />
      <van-cell title="VIVO手机" is-link to="/vivo" />
      <van-cell title="OPPO手机" is-link to="/oppo" />
      <van-cell title="SAMSUNG手机" is-link to="/sansung" />
      <van-cell title="打开家庭成员APP呼叫权限" is-link to="/familyrights" />
    </van-cell-group>
  </div>
</template>

<script>
import Vue from 'vue'
import { NoticeBar, Cell, CellGroup } from 'vant'
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(NoticeBar)
export default {
  name: 'Home',
}
</script>

<style lang="less" scoped>
body,
html {
  width: 100vw;
  height: 100vh;
}
.containor {
  display: flex;
  flex-direction: column;
  padding: 20px 5px 0px 5px;
}
.button {
  margin-bottom: 10px;
  width: 100%;
}
</style>
